var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "flex items-center py-4 border-primary-color border-solid border-b-1",
      },
      [
        _vm.isIconSlotUsed
          ? _c("div", { staticClass: "mr-3" }, [_vm._t("icon")], 2)
          : _vm._e(),
        _c("h2", { staticClass: "font-bold" }, [
          _vm._v(" " + _vm._s(_vm.title) + " "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }